// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-1qF","option":"styles_option__3I5Lt","active":"styles_active__1pnj4"};